import React, { useEffect } from "react";
import Script from "next/script";
import Layout from "components/Layout";
import { get_tdk } from "api/server/tdk";
import {Util,Context,Hooks} from "@xt/xtbase";
const {getOrigin} = Util;
const {useTranslation} = Hooks;
import FinanceHead from "@/components/Pages/Finance/FinanceHead";
import FinanceFaq from "@/components/Pages/Finance/FinanceFaq";
import ModalSubscribe from "@/components/Pages/Finance/ModalSubscribe";
import PageSimpleEarn from "@/components/Pages/Finance/PageSimpleEarn";
import models from "@/models";

export default (props)=>{
  models?.finance?.setScope("SIMPLE_EARN");
  const t = useTranslation();
  return (
    <>
      <Script
        id="jsonLd"
        type="application/ld+json"
        strategy="beforeInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            {
              "@context":"http://schema.org",
              "@type": "FAQPage",
              "mainEntity": [{
                "@type": "Question",
                "name": "${t('finance.faqSimpleEarn1').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSimpleEarn1Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSimpleEarn2').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSimpleEarn2Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSimpleEarn3').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSimpleEarn3Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSimpleEarn4').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSimpleEarn4Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSimpleEarn5').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSimpleEarn5Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSimpleEarn6').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSimpleEarn6Answer').replace(/\"/g,'')}</p>"
                }
              },{
                "@type": "Question",
                "name": "${t('finance.faqSimpleEarn7').replace(/\"/g,'')}",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "<p>${t('finance.faqSimpleEarn7Answer').replace(/\"/g,'')}</p>"
                }
              }]
            }
          `,
        }}
      />
      <Layout style={{overflow: "hidden"}}>
        <FinanceHead/>
        <PageSimpleEarn/>
        <FinanceFaq/>
        <ModalSubscribe/>
      </Layout>
    </>
  );
}
export async function getStaticProps(context){
  const resolvedUrl = "/finance/simple-earn";
  const props = {resolvedUrl,theme:"dark"};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate:60
  }
}



